import React, { useState, useEffect } from "react";
import { get } from "lodash";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/pro-light-svg-icons";
import { getPathWithParam } from "../../utils";
import tenantConfig from "../../mocks/tenantOne.json";
import permissions from "../../mocks/menuPermissions.json";
import authService from "../api-authorization/AuthorizeService";

const menuItems = ["File Specifications", "Map & Transform", "Verify Map"];
const ManageTempMapMenu = ({
  menuList = [],
  flow,
  selectedMenu,
  profileId,
  linkDisable,
  isFixedLength,
}) => {
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  return (
    <ul className="manage-mapper-menu">
      {menuList.map((item) => {
        const childRoutes = get(item, "childRoutes", []);
        let className =
          selectedMenu.indexOf(item.path) !== -1 ||
          childRoutes.filter((route) => {
            return selectedMenu.indexOf(route) !== -1;
          }).length
            ? "selected"
            : "";
        const disabled =
          !linkDisable &&
          menuItems.includes(item.label) &&
          !(linkDisable == 0 && item.label == "loadDefinitionHome");
        if (!isFixedLength && item.label == "File Specifications") {
          return <></>;
        }

        return (
          tenantConfig.mapperSubMenu.includes(item.id) &&
          permissions[roleName].mapperSubMenu[item.id] && (
            <li
              key={item.path}
              className={
                disabled ? "disabled has-tick" : `${className} has-tick`
              }
            >
              <FontAwesomeIcon icon={faCheckCircle} size="1x" />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <Link
                disabled={disabled}
                to={getPathWithParam({
                  path: item.path,
                  pathParam: [flow, profileId],
                })}
              >
                {item.label}
              </Link>
              <span className="open-rounded-corner-top" />
              <span className="open-rounded-corner-bottom" />
            </li>
          )
        );
      })}
    </ul>
  );
};

export default ManageTempMapMenu;
